import { Alert, Col, Row, Space } from 'antd';
import React from 'react';
import dgiprlogo from "../../assets/images/website/dgipr-logo.png";
import NavigationMenu from './NavigationMenu';
import ScrollingText from './ScrollingText';
import { Outlet, useNavigate } from 'react-router-dom';

const HomeContent = ({ isTabletOrMobile }) => {
    const navigate = useNavigate();

    return (
        <Space direction='vertical' size={12} style={{ width: "100%", paddingTop: 30 }}>
            <Row>
                <Col xl={3} lg={3} md={4} sm={24} xs={24} style={{ textAlign: isTabletOrMobile ? "center" : "left" }} >
                    <img src={dgiprlogo} />
                </Col>
                <Col xl={16} lg={16} md={16} sm={24} xs={24} style={{ display: "flex", textAlign: isTabletOrMobile ? "center" : "left", flexDirection: "column" }}>
                    <h1 className='pskagal-subheader' style={{ fontSize: isTabletOrMobile ? 30 : 60, marginBottom: 5, marginTop: 5, color: "#164469" }}>पंचायत समिती, कागल</h1>
                    <h2 className='pskagal-subheader'style={{ fontSize: isTabletOrMobile ? 30 : 60, margin: 0, color: "#000000" }}>Panchayat Samiti, Kagal</h2>
                </Col>
                <Col xl={4} lg={4} md={4} sm={0} xs={0} style={{ textAlign: "right" }} >

                </Col>
            </Row>
            <div>
                <NavigationMenu />
            </div>
            <div>
                <Alert type='error' style={{ textAlign: "center" }} message={<span style={{ fontSize: 18, cursor: "pointer" }} class="blink" onClick={() => { navigate("/grievance") }}><span>स्त्री भ्रूण हत्या/गर्भलिंगनिदान तक्रार अथवा बाल विवाह तक्रार नोंद करण्यासाठी येथे क्लिक करा</span></span>} />
            </div>
            <div>
                <ScrollingText />
            </div>
            <Outlet />
        </Space>
    );
}

export default HomeContent;